// The pulsing sparkle that says the agent is working: beside the chat's
// active turn (Claude's flashing icon), and on a comment sent to the agent
// until its reply lands (#13194). One glyph, so the two read as the same
// signal.
import React from "react";
import { SparkleIcon } from "@phosphor-icons/react";

export const WorkingSparkle: React.FC<{
  /** The chat's turn sparkle is 20px; a comment's row takes the 16px one. */
  size?: "md" | "sm";
  testId?: string;
}> = ({ size = "md", testId }) => (
  <SparkleIcon
    weight="fill"
    aria-hidden="true"
    data-working-sparkle=""
    data-testid={testId}
    className={`${
      size === "sm" ? "h-4 w-4" : "h-5 w-5"
    } shrink-0 animate-pulse text-[#2A3DCB]`}
  />
);
